module.exports = __webpack_public_path__ + "static/media/image-placeholder.7e1b94e8.png";